export default __webpack_public_path__ + "static/media/4-min.2211931f.jpg";